// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__27QlD","resendInfoText":"OnGoingPaymentBox_resendInfoText__x08Mu"};